import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import './Login.css';
import { FaUser, FaLock } from 'react-icons/fa';


const Login = ({ onLogin }) => {
  const [username, setUsername] = useState('');
  const [UserPassword, setPassword] = useState('');
  const [error, setError] = useState('');
  const [rememberMe, setRememberMe] = useState(false);
  const navigate = useNavigate();

  const handleLogin = async (e) => {
    e.preventDefault();
  
    try {
      const response = await fetch('https://webcore.hunzagroupofindustries.com.pk/api/account/login', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ username, UserPassword }),
      });
  
      if (response.status === 200) {
        const data = await response.json();
  
        // Store user details in localStorage
        localStorage.setItem('userID', data.UserID);
        localStorage.setItem('userName', data.UserName);
  
        // Notify parent component
        if (onLogin) onLogin();
  
        // Redirect to dashboard
        navigate('/');
      } else {
        setError('Invalid username or password.');
      }
    } catch (error) {
      setError('Unable to connect to the server. Please try again.');
    }
  };
  
  

  return (
    <div
      className="container-fluid d-flex justify-content-center align-items-center"
      style={{ minHeight: '100vh', backgroundColor: '#f8f9fa' }}
    >
      <div className="card p-4 shadow-lg" style={{ width: '100%', maxWidth: '420px' }}>
        <div className="text-center mb-4">
          <img
            src="https://www.hunzasugar.com.pk/HG-Logo-Mini-e1471250195123.jpg"
            alt="Logo"
            style={{ width: '150px', height: 'auto' }}
          />
        </div>

        <h2 className="text-center mb-4 text-primary">Login</h2>

        <form onSubmit={handleLogin}>
          <div className="mb-3">
            <label htmlFor="username" className="form-label">
              Username
            </label>
            <div className="input-group">
              <span className="input-group-text">
                <FaUser />
              </span>
              <input
                type="text"
                id="username"
                className="form-control"
                value={username}
                onChange={(e) => setUsername(e.target.value)}
                required
              />
            </div>
          </div>

          <div className="mb-3">
            <label htmlFor="UserPassword" className="form-label">
              Password
            </label>
            <div className="input-group">
              <span className="input-group-text">
                <FaLock />
              </span>
              <input
                type="password"
                id="UserPassword"
                className="form-control"
                value={UserPassword}
                onChange={(e) => setPassword(e.target.value)}
                required
              />
            </div>
          </div>

          <div className="mb-3 form-check">
            <input
              type="checkbox"
              id="rememberMe"
              className="form-check-input"
              checked={rememberMe}
              onChange={(e) => setRememberMe(e.target.checked)}
            />
            <label className="form-check-label" htmlFor="rememberMe">
              Remember me
            </label>
          </div>

          {error && <div className="alert alert-danger">{error}</div>}

          <button type="submit" className="btn btn-primary w-100 py-2">
            Login
          </button>
        </form>
      </div>
    </div>
  );
};

export default Login;
